(() => {
  if (customElements.get('sitone-connect')) return;
  class SitoneConnect extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      this.storageKey = 'sitone-newsletter-dismissed-v1';
      const signal = this.controller.signal;
      this.querySelectorAll('[data-sitone-popup-open]').forEach((button) => {
        button.addEventListener('click', () => this.open(), { signal });
      });
      this.querySelectorAll('[data-sitone-popup-close]').forEach((button) => {
        button.addEventListener('click', () => this.dismiss(), { signal });
      });
      this.dialog.addEventListener('cancel', () => this.remember(), { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss();
      }, { signal });
      this.dialog.querySelector('[data-sitone-popup-line]')?.addEventListener('click', () => this.dismiss(), { signal });
      this.dialog.querySelector('form')?.addEventListener('submit', () => this.remember(), { signal });
      if (this.dialog.querySelector('[data-sitone-newsletter-success], [role="alert"]')) {
        this.open();
        return;
      }
      if (this.dataset.autoPopup !== 'true' || this.dataset.designMode === 'true' || ['404', 'cart', 'customers/account', 'customers/login', 'password'].includes(this.dataset.pageType)) return;
      try {
        const until = Number(localStorage.getItem(this.storageKey));
        if (Number.isFinite(until) && until > Date.now()) return;
      } catch (_) {
        // Leave manual registration available when preference storage is blocked.
        return;
      }
      this.timer = setTimeout(() => this.offer(), Number(this.dataset.delay) * 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
    offer() {
      if (!this.isConnected) return;
      const banner = document.querySelector('#shopify-pc__banner');
      const bannerVisible = banner && banner.getBoundingClientRect().height > 0 && getComputedStyle(banner).visibility !== 'hidden';
      const anotherDialog = document.querySelector('dialog[open], details[open] .menu-drawer, .cart-notification.active');
      const typing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      if (document.visibilityState !== 'visible' || bannerVisible || anotherDialog || typing) {
        this.timer = setTimeout(() => this.offer(), 1000);
        return;
      }
      this.open();
    }
    open() {
      if (!this.dialog.open && typeof this.dialog.showModal === 'function') this.dialog.showModal();
    }
    remember() {
      clearTimeout(this.timer);
      try {
        const days = Number(this.dataset.repeatDays) || 7;
        localStorage.setItem(this.storageKey, String(Date.now() + days * 86400000));
      } catch (_) { /* The footer links and form remain usable without storage. */ }
    }
    dismiss() {
      this.remember();
      this.dialog.close();
    }
  }
  customElements.define('sitone-connect', SitoneConnect);

  const ambient = new WeakSet();
  function initializeAmbient(scope) {
    scope.querySelectorAll('[data-sitone-ambient]').forEach((video) => {
      if (ambient.has(video)) return;
      ambient.add(video);
      const toggle = video.closest('section')?.querySelector('[data-sitone-ambient-toggle]');
      if (!toggle) return;
      const update = () => {
        toggle.textContent = video.paused ? '動画を再生' : '動画を一時停止';
        toggle.setAttribute('aria-pressed', String(!video.paused));
      };
      toggle.addEventListener('click', () => {
        if (video.paused) {
          delete video.dataset.userPaused;
          video.play().catch(update);
        } else {
          video.dataset.userPaused = 'true';
          video.pause();
        }
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) video.pause();
          else if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !video.dataset.userPaused) video.play().catch(update);
        });
      }, { threshold: 0.25 });
      observer.observe(video);
      video.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        observer.disconnect();
        video.pause();
      }, { once: true });
    });
  }
  initializeAmbient(document);
  document.addEventListener('shopify:section:load', (event) => initializeAmbient(event.target));
})();
